import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: 100%;
    border-radius: 0.8vw;
    
    justify-content: flex-start; 
    
    overflow-x: auto; 
    overflow-y: hidden;
    
    padding: 0rem 0rem 3rem 4.25rem;
    margin-top: 1rem;
`

export const LineDiv = styled.div`
    width: 80.3vw; 
    height: 0.1vh;
    background-color: #EBEBEB;
    margin-bottom: 0.5rem; 
    margin-left: 0; 
    margin-right: auto;
`

export const ContentDiv = styled.div`
    position: relative; 
    display: flex;
    align-items: center; 
    justify-content: flex-start; 
    width: 100%; 
`

export const MainText = styled.h3`
    font-size: 1vw;
    font-family: 'Inter', sans-serif;
    margin-right: 1vw; 
`

export const FilterDiv = styled.div`
    display: flex;
    height: 4.4vh; 
    border: 1px solid #c4c4c4;
    border-radius: 1vw;
    align-items: center;
    margin-left: 0.5vw;
    padding-left: 0.7vw; 
    padding-right: 0.6vw; 
    font-family: 'Inter', sans-serif;
`

export const BoldedFilterText = styled.p`
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.4vw;
    white-space: nowrap;
`

export const NormalFilterText = styled.p`
    font-size: 1vw;
    margin-left: 0.4vw;
    white-space: nowrap;
`

export const CloseImg = styled.img`
    width: 1.7vw;
    margin-left: 0.2vw;
    padding-left: 0.6vw;
    padding-right: 0.3vw;
    cursor: pointer;
`

export const DeleteDiv = styled.div`
    display: flex;
    align-items: center;
    width: 5.5vw; 
    height: 2.2vh;
    margin-left: 1vw; 
    padding-left: 1vw;
    padding-right: 1vw;
    cursor: pointer;
    background-color: #fff;
    white-space: nowrap; 
`

export const DeleteImg = styled.img`
    width: 1vw;
`

export const DeleteText = styled.p`
    position: relative;
    color: #0090D3;
    margin-left: 0.4vw;
    font-size: 1vw;
    font-weight: 700;
    font-family: 'Inter', sans-serif;
`